import React from 'react';

import * as S from './styles';

type Props = {
  children: React.ReactNode;
};

/**
 * ページ全体のレイアウトのためのコンポーネント
 *
 * @param children ページ内容
 */
export function PageLayout({ children }: Props): React.JSX.Element {
  return <S.Page>{children}</S.Page>;
}
